import {envIsDev} from '../../../../config';
import {getDatadogRum} from '../../../../util/datadog/datadogRum';
import {type BucketedLine} from '../../types';
import {
  type GroupedBackendLinesQueryRuns,
  type GroupedBucketedQueryRuns,
  type GroupedBucketedQueryRunWithGroupedRunConnection,
} from './types';

const DD_RUM = getDatadogRum();

const debugBucketedDataEvents = false;
export function trackedBucketedDataEvent(
  eventName: string,
  context: Record<string, any>
) {
  if (envIsDev && debugBucketedDataEvents) {
    console.log(`Bucketed_data_event: ${eventName}`, context);
  } else {
    DD_RUM.addAction(`Bucketed_data_event: ${eventName}`, context);
  }
}

export function isAggregatedRuns(
  runs:
    | GroupedBucketedQueryRuns
    | GroupedBackendLinesQueryRuns
    | null
    | undefined
): runs is GroupedBucketedQueryRunWithGroupedRunConnection {
  return runs?.__typename === 'GroupedRunConnection';
}

export function profileRenderTimeSaved(
  runsById: Record<string, BucketedLine>,
  type: 'backend' | 'grouped'
) {
  try {
    const numPoints = Object.values(runsById).reduce((acc, run) => {
      const hPoints = (run.historyLines ?? []).reduce((ac, line) => {
        return ac + line.historyLine.length;
      }, 0);
      return acc + hPoints;
    }, 0);
    trackedBucketedDataEvent('Backend_line_render_saved', {
      numRuns: Object.keys(runsById).length,
      numPoints,
      type,
    });
  } catch (e) {
    DD_RUM.addError(new Error('backend lines profiling error'), {
      reason: 'Error profiling backend lines',
      error: e,
    });
    return;
  }
}

export function extractDeltasInfo<
  T extends {deltas?: {delta?: any[]; order?: any[]} | null},
>(
  runs: T | null | undefined
): {
  deltas: any[];
  order: any[];
} {
  return {
    deltas: runs?.deltas?.delta ?? [],
    order: runs?.deltas?.order ?? [],
  };
}
